import { useState, useEffect, useRef } from 'react';

const INTERVALO_MS = 60_000;

/**
 * Recebe a lista de logos da configuração da tela e retorna a URL
 * da logo atualmente ativa. Se houver mais de uma, alterna a cada 60s.
 * Se a lista estiver vazia, retorna null.
 */
export function usePlayerLogos(logosUrls: string[]): string | null {
  const [indice, setIndice] = useState(0);
  const timerRef = useRef<ReturnType<typeof setInterval> | null>(null);

  useEffect(() => {
    setIndice(0);

    if (logosUrls.length <= 1) {
      if (timerRef.current) clearInterval(timerRef.current);
      timerRef.current = null;
      return;
    }

    timerRef.current = setInterval(() => {
      setIndice(prev => (prev + 1) % logosUrls.length);
    }, INTERVALO_MS);

    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, [logosUrls]);

  if (logosUrls.length === 0) return null;
  return logosUrls[indice] ?? logosUrls[0];
}
